export const createBIEvent = (biEventDefinition) => biEventDefinition;
export const createBIEventFactory = (src) => (evid, fields) => createBIEvent({ evid, src, fields });
const hasResponsiveBI = (editorWindow) => editorWindow.hasOwnProperty('responsiveEditorModel');
export const createComponentBI = (biLogger, extraParams = {}) => (event, eventParams) => {
    if (!(event.eventId || event.evid)) {
        return;
    }
    const params = Object.assign(Object.assign({}, extraParams), eventParams);
    if (hasResponsiveBI(window)) {
        const logger = window.responsiveEditorModel.bi.biLoggerFactory.logger();
        return logger.report(Object.assign(Object.assign({ endpoint: 'editor-x' }, event), { params: Object.assign(Object.assign({}, params), { componentType: extraParams.component_type }) }));
    }
    return biLogger === null || biLogger === void 0 ? void 0 : biLogger(event, params);
};
//# sourceMappingURL=createBI.js.map